import { AdminMetricCard } from "@/components/admin";
import type { AdminStatusTone } from "@/lib/adminCodeDisplay";
import type { AdminSettingsStatus } from "../page";

interface SummaryCardsProps {
  status: AdminSettingsStatus;
  loading: boolean;
}

interface SettingsSummaryCard {
  title: string;
  value: string;
  badge: string;
  description: string;
  tone: AdminStatusTone;
  icon: string;
}

const SummaryCards = ({ status, loading }: SummaryCardsProps) => {
  const version = status.version;
  const cards: SettingsSummaryCard[] = [
    { title: "API 애플리케이션", value: loading ? "확인 중" : version?.application ?? "-", badge: "API", description: "현재 응답 중인 서버", tone: "emerald", icon: "ri-server-line" },
    { title: "애플리케이션 버전", value: version?.applicationVersion ?? "-", badge: "VERSION", description: "서버 빌드 버전", tone: "blue", icon: "ri-price-tag-3-line" },
    { title: "릴리즈 ID", value: version?.releaseId ?? "-", badge: "RELEASE", description: "현재 배포 식별자", tone: "blue", icon: "ri-archive-line" },
    { title: "소스 상태", value: version?.sourceDirty ? "변경 포함" : "정상", badge: version?.sourceDirty ? "DIRTY" : "CLEAN", description: "빌드 시점 소스 변경 여부", tone: version?.sourceDirty ? "amber" : "emerald", icon: "ri-git-commit-line" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => <AdminMetricCard key={card.title} {...card} variant="filled" />)}
    </div>
  );
};

export default SummaryCards;
